export default "__VITE_ASSET__DOgOP9sL__"